export default __webpack_public_path__ + "static/media/Poppins-Bold.887d9d2a.svg";